// src/pages/Home.js
import { Container } from "react-bootstrap";
import styles from "../styles/App.module.css";

function Home() {
  return (
    <Container className="container text-center my-5">
      <h1>Welcome🌿</h1>
      <h2 className={styles.Intro}>My name is Lisa David</h2>
      <p className={styles.CredsSize}>(Dipcouns) Reg MBACP (accred)</p>
      <h3>I offer you a calm supportive space</h3>
      <p>
        <span className={styles.Bolded}>Based in Canterbury, Kent</span> —
        Offering sessions in-person and online. Providing a calm and safe space
        where you can talk openly and feel heard without judgement.
        <br />
        <br />
        Whether you're feeling overwhelmed, anxious, stuck, or trying to make
        sense of past experiences, you don’t have to navigate it alone.{" "}
        <span className={styles.Bolded}>
          BACP accredited and over twenty of years of experience
        </span>{" "}
        supporting adults and young people across Canterbury, within the
        community and its schools.
      </p>
    </Container>
  );
}

export default Home;
